<script>
import VClamp from 'vue-clamp';

export default {
  name: 'CpMemberContent',
  directives: {
    margin: require('../../directives/margins').margin,
  },
  components: {
    handleImageError: require('../../mixins/utils').default,
    VClamp,
    TruncateText: require('../TruncateText').default,
  },
  props: {
    member: { type: Object, default: () => ({}) },
    maxLines: { type: Number, default: 2 },
    tag: { type: String, default: '' },
    nameClass: { type: String, default: '' },
    descriptionClass: { type: String, default: '' },
    imageSize: { type: String, default: '40px' },
  },
  methods: {
    navigateTo(path) {
      window.location.href = path;
    },
  },
};
</script>

<template>
  <a :href="member?.permalink ?? null" target="_blank" rel="noopener noreferrer" :disabled="!member?.permalink" class="memberContainer">
    <span v-if="tag" class="member-tag caption">{{ tag }}</span>
    <div class="memberImage">
      <div class="circle-container" :style="{ width: imageSize, height: imageSize }">
        <img :src="`${member.image}`" alt="Member's image" @error="handleImageError" />
      </div>
    </div>
    <span class="textContainer">
      <div class="name-container">
        <p class="caption1 neutral-2-color" :class="nameClass" v-margin="0">{{ member.fullname }}</p>
        <span v-if="member?.badge" class="badge caption1 neutral-2-color">{{ member.badgeType }}</span>
      </div>
      <slot v-if="$scopedSlots.customDescription" name="customDescription" />
      <TruncateText v-else-if="member?.description" :content="member.description" :lineClamp="maxLines" :withMoreButton="false" :textClass="descriptionClass ? descriptionClass : 'caption neutral-2-color'" />
    </span>
  </a>
</template>

<style scoped>
.memberContainer {
  display: flex;
  align-items: center;
  padding: 8px 0;
  margin: 4px 0;
  position: relative;
}
.member-tag {
  position: absolute;
  top: 4px;
  right: 8px;
  display: flex;
  background-color: var(--primary-1);
  color: var(--primary);
  border-radius: 4px;
  padding: 2px 4px;
}
.memberImage {
  border: 1px solid var(--primary);
  margin-right: 10px;
  border-radius: 50%;
}
.circle-container {
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.circle-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.textContainer {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.name-container {
  display: flex;
  align-items: center;
  gap: 4px;
}
.textContainer p {
  width: 100%;
  overflow: hidden;
}
</style>
